module.exports = __webpack_public_path__ + "static/WindingWorlds4-c5a27c362908bd687add8ccb361d871c.png";